import isArray from './is-array';
import isString from './is-string';
function startsWith(arr, e) {
    return (isArray(arr) || isString(arr)) ? arr[0] === e : false;
}
export default startsWith;
//# sourceMappingURL=starts-with.js.map